import { Badge } from '@chakra-ui/react'
import type { ConnectionStatus as ConnectionStatusType } from '@/lib/mqtt-types'

interface ConnectionStatusProps {
  status: ConnectionStatusType
  clientId?: string | null
}

const statusConfig: Record<ConnectionStatusType, { color: string; label: string }> = {
  disconnected: { color: 'gray', label: 'Disconnected' },
  connecting: { color: 'yellow', label: 'Connecting...' },
  connected: { color: 'green', label: 'Connected' },
  error: { color: 'red', label: 'Error' },
}

export function ConnectionStatus({ status, clientId }: ConnectionStatusProps) {
  const config = statusConfig[status]

  return (
    <Badge colorPalette={config.color} variant="subtle" px={2} py={1}>
      <span
        style={{
          display: 'inline-block',
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: 'currentColor',
          marginRight: 6,
        }}
      />
      {config.label}
      {clientId && status === 'connected' && (
        <span style={{ marginLeft: 8, opacity: 0.7 }}>({clientId})</span>
      )}
    </Badge>
  )
}

export default ConnectionStatus
